export default __webpack_public_path__ + "assets/8c382430f673ad2237bbf19e5c8a4b00.png";